import Axios from "axios";
import { prefix } from "@/store/api";

const root = `${prefix}inventory`;

export const poLandedCostApi = {
  list: (payload = {}) => Axios.post(`${root}/get-inv-po-landed-cost-list`, payload),
  purchaseOrders: () => Axios.get(`${root}/get-inv-po-landed-costable-po-list`),
  preview: (payload) => Axios.post(`${root}/preview-inv-po-landed-cost`, payload),
  save: (payload) => Axios.post(`${root}/save-update-inv-po-landed-cost`, payload),
  details: (id) => Axios.get(`${root}/get-inv-po-landed-cost-by-id/${id}`),
  productCost: (poId, productId) => Axios.get(`${root}/get-inv-po-landed-cost-product/${poId}/${productId}`),
};

export default poLandedCostApi;
